import { Responsibilities } from "@/lib/interfaces/embed";
import { Card } from "../../../ui/components/ui/card";
import { getIcon } from "../icon-map";
import { withAlpha } from "./v2-helpers";

export function JobPostsV2Responsibilities({
  brandColor,
  responsibilities,
}: {
  brandColor: string;
  responsibilities?: Responsibilities;
}) {
  const items = responsibilities?.yourResponsibilities || [];
  if (!responsibilities || items.length === 0) return null;

  const iconBg = withAlpha(brandColor, 0.2);

  return (
    <div>
      <div className="text-center max-w-2xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold tracking-tight text-gray-900">
          <span>Deine </span>
          <span style={{ color: brandColor }}>Aufgaben</span>
        </h2>
        {responsibilities.description ? <p className="mt-3 text-sm md:text-base text-gray-600">{responsibilities.description}</p> : null}
      </div>

      <div className="mt-10">
        <Card className="p-6 md:p-8 shadow-sm">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-6">
            {items.map((item, idx) => {
              const Icon = item.iconKey ? getIcon(item.iconKey) : null;
              return (
                <div key={`${item.title}-${idx}`} className="flex gap-3">
                  <div className="pt-0.5">
                    <div
                      className="h-9 w-9 rounded-full flex items-center justify-center"
                      style={{ backgroundColor: iconBg }}
                      aria-hidden="true"
                    >
                      {Icon ? (
                        <span className="[&>svg]:w-4 [&>svg]:h-4" style={{ color: brandColor }}>
                          <Icon />
                        </span>
                      ) : null}
                    </div>
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-gray-900">{item.title}</div>
                    <div className="mt-1 text-sm text-gray-600 leading-relaxed">{item.description}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </Card>
      </div>
    </div>
  );
}

